(function() {
  'use strict';

  angular.module('app')
    .controller('CloseOutCtrl', CloseOutCtrl);

  /** @ngInject */
  function CloseOutCtrl($uibModalInstance, $scope, header, data, fields) {
    $scope.header = header;
    $scope.attributes = data.attributes;
    $scope.PurchaseDate = {
      date: new Date(),
      open: false
    };
    $scope.dateFormat = 'MM/dd/yyyy';

    $scope.getDomainValues = function getDomainValues(field) {
      return _.find(fields, {
        'name': field
      }).domain.codedValues;
    };

    $scope.fOpenStart = function(item) {
      item.opened = true;
    };

    $scope.finishCloseOut = function() {
      $uibModalInstance.close({
        PurchaseDate: $scope.PurchaseDate,
        Sold_type: $scope.Sold_type,
        TaxForfeitedStatus: $scope.TaxForfeitedStatus,
        PurchasedPrice: $scope.PurchasedPrice
      });
    };

    $scope.cancel = function() {
      $uibModalInstance.dismiss();
    };
  }
})();
